import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "out-header" }
const _hoisted_2 = { class: "lab__market" }
const _hoisted_3 = { class: "lab__market --mobile" }
const _hoisted_4 = { class: "lab__picture" }
const _hoisted_5 = { class: "lab__top-content container-flex" }
const _hoisted_6 = { class: "lab__go-back-text" }
const _hoisted_7 = { class: "lab__info" }
const _hoisted_8 = { class: "lab__subtitle" }
const _hoisted_9 = { class: "lab__title" }
const _hoisted_10 = { class: "lab__info-more" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "lab__links-mobile-box" }
const _hoisted_14 = { class: "lab__subtitle-mob" }
const _hoisted_15 = { class: "lab__title-mob" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = {
  key: 0,
  class: "lab__content"
}
const _hoisted_18 = {
  key: 0,
  class: "lab__content-header"
}
const _hoisted_19 = { class: "lab__short" }
const _hoisted_20 = { class: "lab__short-icon" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "lab__content"
}
const _hoisted_24 = { class: "lab__content-header" }
const _hoisted_25 = { class: "lab__short" }
const _hoisted_26 = { class: "lab__short-icon" }
const _hoisted_27 = { class: "lab__content-title" }
const _hoisted_28 = { class: "lab__content-space lab__content-lang" }
const _hoisted_29 = { class: "lab__content-lang-icon" }
const _hoisted_30 = {
  key: 2,
  class: "lab__content"
}
const _hoisted_31 = { class: "lab__content-header" }
const _hoisted_32 = { class: "lab__short" }
const _hoisted_33 = { class: "lab__short-icon" }
const _hoisted_34 = { class: "lab__content-title" }
const _hoisted_35 = { class: "lab__content-space" }
const _hoisted_36 = {
  key: 3,
  class: "lab__content"
}
const _hoisted_37 = { class: "lab__content-header" }
const _hoisted_38 = { class: "lab__short" }
const _hoisted_39 = { class: "lab__short-icon" }
const _hoisted_40 = { class: "lab__content-title" }
const _hoisted_41 = { class: "lab__content-space" }
const _hoisted_42 = { class: "lab__documents" }
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "lab__documents-svg" }, null, -1)
const _hoisted_45 = { class: "lab__documents-text" }
const _hoisted_46 = {
  key: 4,
  class: "lab__content"
}
const _hoisted_47 = { class: "lab__content-header" }
const _hoisted_48 = { class: "lab__short" }
const _hoisted_49 = { class: "lab__short-icon" }
const _hoisted_50 = { class: "lab__content-title" }
const _hoisted_51 = ["innerHTML"]

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { catchErrorShow } from '@/utils';
import IconWorkbook from '@/components/icons/Workbook.vue';
import InfoImportant from '@/components/icons/InfoImportant.vue';
import LicenceInfo from '@/components/LicenceInfo.vue';
import InfoGlobe from '@/components/icons/InfoGlobe.vue';
import InfoVideo from '@/components/icons/InfoVideo.vue';
import InfoDoc from '@/components/icons/InfoDoc.vue';
import InfoSysReq from '@/components/icons/InfoSysReq.vue';
import MobileModal from '@/components/MobileModal.vue';
import IconArrowBack from '@/components/icons/ArrowBack.vue';
import { Manual, FileStatusEnum, DocumentTypeEnum, SystemReq } from '@/types/manuals';
import { ErrorCodeEnum } from '@/types/httpResponses';
import { createFieldByManuals } from '@/router/Admin/builderManuals';
import LangIcon from '@/components/Form/LangIcon.vue';
import Links from '@/router/Laboratories/components/Links.vue';
import TemporaryUnavailable from '@/router/Alerts/TemporaryUnavailable/index.vue';
import { LabData, SysReq } from '@/types/LabData';
import CarouselVideoCards from '@/components/Carousel/CarouselVideoCards.vue';
import services from '../services';
import SkeletonLaboratory from './components/SkeletonLaboratory.vue';
// import fakeData from '@/assets/fakeData/laboratory';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  id: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const { t } = useI18n();

const props = __props;

const store = useStore();
const isPortalClosed = computed(() => store.getters['Common/isPortalClosed']);
const isAdmin = computed(() => store.getters.isAdmin);
const isModerator = computed(() => store.getters.isModerator);
const isDistributor = computed(() => store.getters.isDistributor);
const isSuAccessRole = computed(() => store.getters.isSuAccessRole);

const product = ref<LabData>({
  active_for_user: false,
  app_img: {
    original: '',
    '240x160': '',
    '400x280': '',
  },
  demo_counter: 0,
  demo_mode: false,
  description: '',
  authors_signature: '',
  system_requirements_type: SystemReq.Standard,
  system_requirements: '',
  id: null,
  license_state: null,
  self_license_state: false,
  name: '',
  offer: {
    id: null,
    price_per_month: null,
    price_per_month_with_discount: null,
    discount_per_month: null,
    type: '',
  },
  has_workbook: false,
  workbook_url: '',
  subsection: {
    shortname: '',
    name: '',
  },
  uuid: '',
  links: [],
  manuals: [],
  supported_locales: [],
  background_img: '',
});

const isLoading = ref(false);
const isOpen = ref(false);
const isAuthed = computed(() => store.getters.isAuthed);
const subsectionName = computed(() => (product.value?.subsection?.name ? `${product.value?.subsection?.name}` : ''));
const subtitle = computed(() => `${t('labs.virtualLab', { name: subsectionName.value })}`);
const userLang = store.getters.lang;
const sysReq = computed(() => {
  const data = store.getters['Common/systemRequirements'];
  return data.find((x: SysReq) => x.locale === userLang)?.text;
});

const showMarketText = computed(
  () => !isAdmin.value && !isModerator.value && !isDistributor.value
      && product.value.license_state === false
);

const fieldSystemRequirements = computed(
  () => (product.value.system_requirements_type === SystemReq.Standard
    ? sysReq.value
    : product.value.system_requirements)
);

const loadedManuals = computed(() => product?.value?.manuals
  .filter((item: Manual) => item.locales[0].file_status === FileStatusEnum.loaded) || []);

const videoInstructions = computed(() => (loadedManuals.value
  ? createFieldByManuals(loadedManuals.value, DocumentTypeEnum.Video)
    .sort((a, b) => a.order - b.order)
  : []));

const currentLocaleIndex = computed(() => store.getters['Locales/currentLocaleIndex']);

const usersGuides = computed(() => (loadedManuals.value
  ? createFieldByManuals(loadedManuals.value, DocumentTypeEnum.Document)
    .sort((a, b) => a.order - b.order)
  : []));

const launchFunction = async () => {
  try {
    isLoading.value = true;
    if (isAuthed.value) {
      product.value = await services.getLaboratoryById(props.id);
    } else {
      product.value = await services.getPublicLaboratoryById(props.id);
    }

    if (isPortalClosed.value) {
      store.commit('Common/SET_IS_PORTAL_CLOSED', false);
    }
    // product.value = fakeData;
  } catch (err: any) {
    if (err.response.status === ErrorCodeEnum.BadRequest) {
      if (!isPortalClosed.value) {
        store.commit('Common/SET_IS_PORTAL_CLOSED', true);
      }

      return;
    }

    catchErrorShow(err, t);
  } finally {
    isLoading.value = false;
  }
};

launchFunction();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isPortalClosed.value && !isSuAccessRole.value)
      ? (_openBlock(), _createBlock(TemporaryUnavailable, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (isLoading.value)
            ? (_openBlock(), _createBlock(SkeletonLaboratory, { key: 0 }))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", null, [
            (showMarketText.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('textToMarket')), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('textToMarketMobile')), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "lab__go-back ui-btn --style-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(IconArrowBack),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("toMainPage")), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(subtitle.value), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(product.value.name), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(LicenceInfo, { product: product.value }, null, 8, ["product"]),
                  (product.value.has_workbook && product.value.workbook_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: product.value.workbook_url,
                        class: "lab__workbook",
                        target: "_blank"
                      }, [
                        _createVNode(IconWorkbook, { class: "lab__workbook-icon" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("labs.workbook")), 1)
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("picture", null, [
                _createElementVNode("img", {
                  src: product.value.background_img || '/img/empty/placeholderBg.webp',
                  alt: product.value.name,
                  class: "lab__background",
                  loading: "eager"
                }, null, 8, _hoisted_12)
              ]),
              _createVNode(Links, {
                class: "lab__links-desktop",
                product: product.value,
                onShowMobileModal: _cache[0] || (_cache[0] = ($event: any) => {isOpen.value = true;})
              }, null, 8, ["product"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(subtitle.value), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(product.value.name), 1),
              _createVNode(Links, {
                class: "lab__links-mobile",
                product: product.value,
                onShowMobileModal: _cache[1] || (_cache[1] = ($event: any) => {isOpen.value = true;})
              }, null, 8, ["product"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (product.value.authors_signature || product.value.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (product.value.authors_signature)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(InfoImportant)
                            ]),
                            _createElementVNode("div", {
                              class: "lab__content-title",
                              innerHTML: product.value.authors_signature
                            }, null, 8, _hoisted_21)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (product.value.description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "lab__content-space lab__editor-content",
                          innerHTML: product.value.description
                        }, null, 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (product.value.supported_locales)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(InfoGlobe)
                        ]),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('fields.supported_locales')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.supported_locales, (lang) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `lang-${lang}`,
                          class: "lab__content-lang-item"
                        }, [
                          _createElementVNode("span", _hoisted_29, [
                            _createVNode(LangIcon, { lang: lang }, null, 8, ["lang"])
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref(t)(`languages['${lang}']`)), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (videoInstructions.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(InfoVideo)
                        ]),
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('labelVideos')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(CarouselVideoCards, {
                        class: "",
                        list: videoInstructions.value,
                        isVideo: ""
                      }, null, 8, ["list"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (usersGuides.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(InfoDoc)
                        ]),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)('labelDocs')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersGuides.value, (doc) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: `doc-link-${doc.id}`,
                            href: doc.locales[currentLocaleIndex.value].file,
                            target: "_blank",
                            class: "lab__documents-link"
                          }, [
                            _hoisted_44,
                            _createElementVNode("div", _hoisted_45, _toDisplayString(doc.locales[currentLocaleIndex.value].caption), 1)
                          ], 8, _hoisted_43))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (fieldSystemRequirements.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(InfoSysReq)
                        ]),
                        _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(t)('fields.labelSystemReq')), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "lab__content-space lab__editor-content",
                      innerHTML: fieldSystemRequirements.value
                    }, null, 8, _hoisted_51)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, !isLoading.value]
          ])
        ], 64)),
    _createVNode(MobileModal, {
      isOpen: isOpen.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (isOpen.value = false))
    }, null, 8, ["isOpen"])
  ]))
}
}

})